import { gql } from '@apollo/client'

export const emailTakenQuery = gql`
  query emailTakenQuery($emailTakenInput: EmailTakenInput!) {
    emailTaken(emailTakenInput: $emailTakenInput)
  }
`
